import { path } from 'ramda';
const ID = 'notif';

export const getNotifErrors = path([ID, 'errors']);
export const getNotifSuccess = path([ID, 'success']);
